// extracted by mini-css-extract-plugin
export default {"checkedBlock":"SuperCheckbox_checkedBlock__meRus"};